import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { RcCompanyMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/rc-company-metadata/rc-company-metadata.component.abstract';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-rc-company-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, SharedBusinessMetadataV2Component],
  templateUrl: './rc-company-metadata-v2.component.html',
})
export class RcCompanyMetadataV2Component extends RcCompanyMetadataComponentAbstract {}
